/* eslint-disable jsdoc/require-param */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable valid-jsdoc */
/* eslint-disable jsdoc/require-returns */
/* eslint-disable @typescript-eslint/no-this-alias */
import { Browser } from '@syncfusion/ej2-base';
import { CanvasRenderer } from './rendering/canvas-renderer';
import { DiagramRenderer } from './rendering/renderer';
import { Size } from './primitives/size';
import { SnapConstraints } from './enum/enum';
import { setAttributeHtml, setAttributeSvg, createHtmlElement } from './utility/dom-util';
import { Rect } from './primitives/rect';
import { createSvgElement, getHTMLLayer } from './utility/dom-util';
import { getDiagramLayerSvg } from './utility/dom-util';
import { checkBrowserInfo } from './utility/diagram-util';
import { DiagramHtmlElement } from './core/elements/html-element';
import { DiagramNativeElement } from './core/elements/native-element';
import { LinearGradient } from './core/appearance';
let storeFormat;
/**
 * Print and Export Settings
 */
export class PrintAndExport {
    constructor(diagram) {
        this.printWindow = undefined;
        //833683 - Method for closing the newly opened print window.
        this.closePrintWindow = () => {
            if (this.printWindow && !this.printWindow.closed) {
                this.printWindow.close();
            }
        };
        this.diagram = diagram;
    }
    /**
     * To Export the diagram
     *
     * @private
     */
    exportDiagram(options) {
        let fileType;
        let customBounds;
        let content;
        const content1 = '';
        let data = 'data';
        //let mode: string;
        const buffers = [];
        let margin = options.margin || {};
        const region = options && options.region ? options.region : 'Content';
        // isBlazor code removed
        const mode = options && options.mode ? options.mode : 'Download';
        const bounds = this.getDiagramBounds(region, options);
        if (options.bounds) {
            customBounds = true;
            bounds.x = options.bounds.x ? options.bounds.x : bounds.x;
            bounds.y = options.bounds.y ? options.bounds.y : bounds.y;
            bounds.width = options.bounds.width || bounds.width;
            bounds.height = options.bounds.height || bounds.height;
        }
        margin = {
            top: margin.top !== undefined ? margin.top : 25,
            bottom: margin.bottom !== undefined ? margin.bottom : 25,
            right: margin.right !== undefined ? margin.right : 25,
            left: margin.left !== undefined ? margin.left : 25
        };
        const nodes = this.diagram.nodes;
        if (region !== 'PageSettings') {
            bounds.x -= margin.left;
            bounds.y -= margin.top;
            bounds.width += margin.left + margin.right;
            bounds.height += margin.top + margin.bottom;
        }
        const fileName = options.fileName || 'diagram';
        if (options.format !== 'SVG') {
            data = this.setCanvas(options, bounds, margin, mode, customBounds, region, fileName);
            if (data !== null) {
                return data;
            }
        }
        else {
            fileType = options.format;
            options.bounds = bounds;
            options.margin = margin;
            const svg = content = this.diagramAsSvg(options, margin);
            if (mode === 'Data') {
                // isBlazor code removed
                return content;
            }
            const buffer = new XMLSerializer().serializeToString(svg);
            buffers.push(buffer);
        }
        if (mode === 'Download' && data !== null) {
            let browserInfo;
            // Ensure this for Safari
            // if (Browser.info.name === 'msie' && Number(Browser.info.version) < 10 || Browser.info.name === 'webkit') {
            //     let info: string = Browser.info.name === 'webkit' ? 'Safari' : 'IE-9';
            //     alert('Downloading option is not supported in ' + info + ', Please use the returned data');
            //     return content;
            // } else {
            for (let b = 0; b < buffers.length; b++) {
                const blob = new Blob([buffers[parseInt(b.toString(), 10)]], { type: 'application/octet-stream' });
                if (Browser.info.name === 'msie') {
                    window.navigator.msSaveOrOpenBlob(blob, fileName + '.' + fileType);
                }
                else {
                    const pom = createHtmlElement('a', { 'download': fileName + '.' + fileType });
                    const url = URL.createObjectURL(blob);
                    pom.href = url;
                    const e = document.createEvent('MouseEvents');
                    e.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                    pom.dispatchEvent(e);
                }
            }
        }
        return null;
    }
    setCanvas(options, bounds, margin, mode, customBounds, region, fileName) {
        let content;
        options.bounds = bounds;
        options.region = region;
        const scaleX = 'scaleX';
        const scaleY = 'scaleY';
        const scaleOffsetX = 'scaleOffsetX';
        const scaleOffsetY = 'scaleOffsetY';
        this.setScaleValueforCanvas(options, bounds);
        const canvas = this.diagramAsCanvas({
            bounds: bounds, margin: margin, region: region, scaleX: options[`${scaleX}`],
            scaleY: options[`${scaleY}`], scaleOffsetX: options[`${scaleOffsetX}`], scaleOffsetY: options[`${scaleOffsetY}`]
        }, customBounds);
        let image;
        if (options.format === 'JPG') {
            image = content = storeFormat = canvas.toDataURL('image/jpeg');
        }
        else if (options.format === 'BMP') {
            image = content = storeFormat = canvas.toDataURL('image/bmp');
        }
        else {
            image = content = storeFormat = canvas.toDataURL();
        }
        if (mode === 'Data') {
            return content;
        }
        this.canvasMultiplePage(options, canvas, margin, image, fileName);
        return null;
    }
    canvasMultiplePage(options, canvas, margin, image, fileName) {
        let images = [];
        const imageData = image.substring(image.indexOf(':') + 1, image.indexOf(';'));
        let imageFormat = imageData.substring(imageData.indexOf('/') + 1);
        if (imageFormat === 'jpeg') {
            imageFormat = undefined;
        }
        else {
            imageFormat = imageFormat.toUpperCase();
        }
        const fileType = imageFormat || 'JPG';
        if (options.multiplePage) {
            options.pageHeight = options.pageHeight ? options.pageHeight : this.diagram.pageSettings.height;
            options.pageWidth = options.pageWidth ? options.pageWidth : this.diagram.pageSettings.width;
            options.pageHeight = options.pageHeight ? options.pageHeight : canvas.width;
            options.pageWidth = options.pageWidth ? options.pageWidth : canvas.height;
            margin = options.margin || {};
            if (options.pageOrientation) {
                if ((options.pageOrientation === 'Landscape' && options.pageHeight > options.pageWidth) ||
                    options.pageOrientation === 'Portrait' && options.pageWidth > options.pageHeight) {
                    const temp = options.pageWidth;
                    options.pageWidth = options.pageHeight;
                    options.pageHeight = temp;
                }
            }
            options.margin = {
                top: !isNaN(margin.top) ? margin.top : 0,
                bottom: !isNaN(margin.bottom) ? margin.bottom : 0,
                left: !isNaN(margin.left) ? margin.left : 0,
                right: !isNaN(margin.right) ? margin.right : 0
            };
            const attr = {
                'id': this.diagram.element.id + '_printImage',
                'src': image
            };
            const img = createHtmlElement('img', attr);
            img.onload = () => {
                images = this.getMultipleImage(img, options, true);
                this.exportImage(images, fileName, fileType, image);
            };
        }
        else {
            images = [image];
            this.exportImage(images, fileName, fileType, image);
        }
    }
    exportImage(images, fileName, fileType, image) {
        const buffers = [];
        const length = (!(images instanceof HTMLElement)) ? images.length : 0;
        for (let g = 0; g < length; g++) {
            image = images[parseInt(g.toString(), 10)];
            image = image.replace(/^data:[a-z]*;,/, '');
            const image1 = image.split(',');
            const byteString = atob(image1[1]);
            const buffer = new ArrayBuffer(byteString.length);
            const intArray = new Uint8Array(buffer);
            for (let i = 0; i < byteString.length; i++) {
                intArray[parseInt(i.toString(), 10)] = byteString.charCodeAt(i);
            }
            buffers.push(buffer);
        }
        // Ensure this for safari
        // if (Browser.info.name === 'msie' && Number(Browser.info.version) < 10 || Browser.info.name === 'webkit') {
        //     let browserInfo: string = Browser.info.name === 'webkit' ? 'Safari' : 'IE-9';
        //     alert('Downloading option is not supported in ' + browserInfo + ', Please use the returned data');
        //     return content;
        // } else {
        for (let j = 0; j < buffers.length; j++) {
            const b = new Blob([buffers[parseInt(j.toString(), 10)]], { type: 'application/octet-stream' });
            if (Browser.info.name === 'msie') {
                window.navigator.msSaveOrOpenBlob(b, fileName + '.' + fileType);
            }
            else {
                const htmlElement = createHtmlElement('a', { 'download': fileName + '.' + fileType });
                const urlLink = URL.createObjectURL(b);
                htmlElement.href = urlLink;
                const mouseEvent = document.createEvent('MouseEvents');
                mouseEvent.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                setTimeout(() => {
                    htmlElement.dispatchEvent(mouseEvent);
                }, ((j + 1) * 5));
            }
        }
    }
    /**   @private  */
    getObjectsBound(options) {
        const nodes = this.diagram.nodes;
        let nodebounds;
        for (const node of nodes) {
            if (node.visible) {
                if (((options.format !== 'SVG' && !(node instanceof DiagramNativeElement) && !(node instanceof DiagramHtmlElement))
                    || (options.format === 'SVG' && !(node instanceof DiagramHtmlElement)))) {
                    if (!nodebounds) {
                        nodebounds = node.wrapper.outerBounds;
                    }
                    else {
                        nodebounds = nodebounds.uniteRect(node.wrapper.outerBounds);
                    }
                }
            }
        }
        const connectors = this.diagram.connectors;
        for (const connector of connectors) {
            if (connector.visible) {
                if (!nodebounds) {
                    nodebounds = connector.wrapper.outerBounds;
                }
                else {
                    nodebounds = nodebounds.uniteRect(connector.wrapper.outerBounds);
                }
            }
        }
        return nodebounds || new Rect(0, 0, 0, 0);
    }
    /**   @private  */
    getDiagramBounds(mode, options) {
        const rect = this.getObjectsBound(options);
        let left = rect.left;
        let top = rect.top;
        let right = rect.right - rect.left;
        let bottom = rect.bottom - rect.top;
        if (mode !== 'Content') {
            if (this.diagram.pageSettings && this.diagram.pageSettings.multiplePage) {
                left = rect.left;
                top = rect.top;
                if (this.diagram.pageSettings.width) {
                    left = Math.floor(left / this.diagram.pageSettings.width) * this.diagram.pageSettings.width;
                    right = Math.ceil(rect.right / this.diagram.pageSettings.width) * this.diagram.pageSettings.width - left;
                }
                if (this.diagram.pageSettings.height) {
                    top = Math.floor(top / this.diagram.pageSettings.height) * this.diagram.pageSettings.height;
                    bottom = Math.ceil(rect.bottom / this.diagram.pageSettings.height) * this.diagram.pageSettings.height - top;
                }
                if ((rect.width === 0) && this.diagram.pageSettings.width !== null) {
                    right = this.diagram.pageSettings.width;
                }
                if ((rect.height === 0) && this.diagram.pageSettings.height !== null) {
                    bottom = this.diagram.pageSettings.height;
                }
            }
            else {
                if (this.diagram.pageSettings.width) {
                    left = 0;
                    right = this.diagram.pageSettings.width;
                }
                if (this.diagram.pageSettings.height) {
                    top = 0;
                    bottom = this.diagram.pageSettings.height;
                }
            }
        }
        //884801-After zooming and exporting the HTML content, the scroll Padding value is not considered
        if (this.diagram.scrollSettings.padding) {
            const scrollpadding = this.diagram.scrollSettings.padding;
            left -= scrollpadding.left;
            top -= scrollpadding.top;
            right += (scrollpadding.left + scrollpadding.right);
            bottom += (scrollpadding.top + scrollpadding.bottom);
        }
        const svgBounds = new Rect();
        svgBounds.x = left;
        svgBounds.y = top;
        svgBounds.width = right;
        svgBounds.height = bottom;
        return svgBounds;
    }
    setScaleValueforCanvas(options, bounds) {
        const scaleX = 'scaleX';
        const scaleY = 'scaleY';
        const scaleOffsetX = 'scaleOffsetX';
        const scaleOffsetY = 'scaleOffsetY';
        options[`${scaleX}`] = 1;
        options[`${scaleY}`] = 1;
        options[`${scaleOffsetX}`] = 0;
        options[`${scaleOffsetY}`] = 0;
        options.pageHeight = options.pageHeight || this.diagram.pageSettings.height;
        options.pageWidth = options.pageWidth || this.diagram.pageSettings.width;
        let pageOrientation = options.pageOrientation || this.diagram.pageSettings.orientation;
        if (!pageOrientation) {
            pageOrientation = 'Portrait';
        }
        if (pageOrientation === 'Portrait') {
            if (options.pageWidth > options.pageHeight) {
                const temp = options.pageHeight;
                options.pageHeight = options.pageWidth;
                options.pageWidth = temp;
            }
        }
        else {
            if (options.pageHeight > options.pageWidth) {
                const temp = options.pageWidth;
                options.pageWidth = options.pageHeight;
                options.pageHeight = temp;
            }
        }
        if (options.pageWidth && options.pageHeight && !options.multiplePage) {
            options.stretch = 'Meet';
        }
        const height = options.pageHeight || bounds.height;
        const width = options.pageWidth || bounds.width;
        if (options.stretch === 'Stretch' || options.stretch === 'Meet' || options.stretch === 'Slice') {
            options[`${scaleX}`] = width / bounds.width;
            options[`${scaleY}`] = height / bounds.height;
            if (options.stretch === 'Meet') {
                options[`${scaleX}`] = options[`${scaleY}`] = Math.min(options[`${scaleX}`], options[`${scaleY}`]);
                options[`${scaleOffsetY}`] = (options.pageHeight - bounds.height * options[`${scaleX}`]) / 2;
                options[`${scaleOffsetX}`] = (options.pageWidth - bounds.width * options[`${scaleX}`]) / 2;
            }
            else if (options.stretch === 'Slice') {
                options[`${scaleX}`] = options[`${scaleY}`] = Math.max(options[`${scaleX}`], options[`${scaleY}`]);
            }
            bounds.width = width;
            bounds.height = height;
        }
        bounds.x *= options[`${scaleX}`];
        bounds.y *= options[`${scaleY}`];
    }
    diagramAsSvg(options, margin) {
        const svg = this.diagram.createSvg(this.diagram.element.id + '_diagram_svg', options.bounds.width, options.bounds.height);
        document.body.appendChild(svg);
        let g = createSvgElement('g', { 'id': this.diagram.element.id + '_pageBackground' });
        const region = options && options.region ? options.region : 'Content';
        const bounds = this.getDiagramBounds(region, options);
        const left = bounds.x;
        const top = bounds.y;
        const width = bounds.width;
        const height = bounds.height;
        svg.appendChild(g);
        let attr = {
            'x': String(left),
            'y': String(top), 'width': String(width), 'height': String(height)
        };
        setAttributeSvg(g, attr);
        this.setTransform(g, options.bounds, margin);
        const gradient = document.getElementById(this.diagram.element.id + 'gradient_pattern');
        if (gradient) {
            // 914031: Export function breaks gradient background of nodes in the diagram
            svg.appendChild(gradient.cloneNode(true));
        }
        attr = {
            'x': String(left),
            'y': String(top), 'width': String(width + margin.left + margin.right), 'height': String(height + margin.top + margin.bottom)
        };
        const backimage = document.getElementById(this.diagram.element.id + '_backgroundImageLayer').cloneNode(true);
        setAttributeSvg(backimage, attr);
        svg.appendChild(backimage);
        this.setTransform(backimage, bounds, margin);
        const backRect = document.getElementById(this.diagram.element.id + '_backgroundLayerrect').cloneNode(true);
        setAttributeSvg(backRect, attr);
        svg.appendChild(backRect);
        this.setTransform(backRect, bounds, margin);
        if (this.diagram.mode === 'SVG') {
            let element;
            let i;
            const diagramLayerSVG = getDiagramLayerSvg(this.diagram.element.id);
            svg.appendChild(diagramLayerSVG.getElementById(this.diagram.diagramLayer.id).cloneNode(true));
            for (i = 0; i < svg.childNodes.length; i++) {
                element = svg.childNodes[parseInt(i.toString(), 10)];
                if (element.id === this.diagram.element.id + '_diagramLayer') {
                    this.setTransform(element, bounds, margin);
                }
            }
        }
        else {
            g = createSvgElement('g', { 'id': this.diagram.element.id + '_diagramLayer' });
            svg.appendChild(g);
            this.setTransform(g, options.bounds, margin);
            //renderLabels
            const renderer = new DiagramRenderer('', null, true);
            const htmlLayer = getHTMLLayer(this.diagram.element.id);
            this.diagram.renderDiagramElements(svg, renderer, htmlLayer, false);
        }
        document.body.removeChild(svg);
        return svg;
    }
    setTransform(element, bounds, margin) {
        element.setAttribute('transform', 'translate(' + (-bounds.x + margin.left) + ', ' +
            (-bounds.y + margin.top) + ')');
    }
    diagramAsCanvas(options, customBounds) {
        const scaleX = 'scaleX';
        const scaleY = 'scaleY';
        const scaleOffsetX = 'scaleOffsetX';
        const scaleOffsetY = 'scaleOffsetY';
        let element;
        const elements = [];
        let region = options.bounds;
        const margin = options.margin;
        const mode = options.region;
        let pageBounds = this.getDiagramBounds(mode, options);
        const bgColor = this.diagram.pageSettings.background.color;
        const canvas = CanvasRenderer.createCanvas(this.diagram.element.id + '_diagram', options.bounds.width, options.bounds.height);
        //canvas.setAttribute('style', 'position:absolute;top:135px;left:160px;');
        const context = canvas.getContext('2d');
        context.translate(-region.x, -region.y);
        context.save();
        context.fillStyle = (this.diagram.pageSettings.background.color === 'transparent') ? 'white' :
            this.diagram.pageSettings.background.color;
        region = mode === 'Content' ? pageBounds : region;
        context.fillRect(region.x, region.y, region.width, region.height);
        const bgImg = this.diagram.pageSettings.background;
        if (bgImg && bgImg.source) {
            pageBounds = this.getDiagramBounds(mode, options);
            const image = new Image();
            image.src = bgImg.source;
            const proportionX = pageBounds.width / image.width;
            const proportionY = pageBounds.height / image.height;
            let x = pageBounds.x;
            let y = pageBounds.y;
            let width = pageBounds.width;
            let height = pageBounds.height;
            const exportable = this.isImageExportable(bgImg);
            if (bgImg.scale !== 'None' && bgImg.align !== 'None') {
                const proportion = bgImg.scale === 'Meet' ? Math.min(proportionX, proportionY) : Math.max(proportionX, proportionY);
                width = proportion * image.width;
                height = proportion * image.height;
                if (bgImg.align.indexOf('xmid') > -1) {
                    x += (pageBounds.width - width) / 2;
                }
                else if (bgImg.align.indexOf('xmax') > -1) {
                    x = x + pageBounds.width - width;
                }
                if (bgImg.align.indexOf('ymid') > -1) {
                    y += (pageBounds.height - height) / 2;
                }
                else if (bgImg.align.indexOf('ymax') > -1) {
                    y = y + pageBounds.height - height;
                }
                if (this.diagram.pageSettings.background.color === 'none' || this.diagram.pageSettings.background.color === 'transparent') {
                    context.fillStyle = 'white';
                    context.fillRect(pageBounds.x * options[`${scaleX}`], pageBounds.y * options[`${scaleY}`], pageBounds.width * options[`${scaleX}`], pageBounds.height * options[`${scaleY}`]);
                }
                if (exportable) {
                    context.drawImage(image, x, y, proportion * image.width, proportion * image.height);
                }
            }
            else if (exportable) {
                context.drawImage(image, x, y, pageBounds.width, pageBounds.height);
            }
        }
        else {
            context.fillStyle = bgColor === 'transparent' ? 'white' : bgColor;
            context.fillRect((pageBounds.x * options[`${scaleX}`]) - margin.left, (pageBounds.y * options[`${scaleY}`]) - margin.top, (pageBounds.width * options[`${scaleX}`]) + margin.left + margin.right, (options[`${scaleY}`] * pageBounds.height) + margin.top + margin.bottom);
        }
        const brColor = this.diagram.pageSettings.background.color;
        const brWidth = this.diagram.pageSettings.width;
        if (brWidth) {
            context.strokeStyle = brColor === 'none' ? 'transparent' : brColor;
            context.lineWidth = brWidth;
            context.strokeRect(pageBounds.x * options[`${scaleX}`], pageBounds.y * options[`${scaleY}`], pageBounds.width * options[`${scaleX}`], pageBounds.height * options[`${scaleY}`]);
        }
        context.restore();
        const htmlLayer = getHTMLLayer(this.diagram.element.id);
        const renderer = new DiagramRenderer('', null, false);
        this.updateObjectValue(options[`${scaleX}`], options[`${scaleOffsetX}`], options[`${scaleOffsetY}`], true);
        this.diagram.renderDiagramElements(canvas, renderer, htmlLayer, false, true);
        this.updateObjectValue(options[`${scaleX}`], options[`${scaleOffsetX}`], options[`${scaleOffsetY}`], false);
        return canvas;
    }
    updateWrapper(canvas, value, scaleOffsetX, scaleOffsetY, isExport) {
        if (canvas && canvas.length > 0) {
            for (let j = 0; j < canvas.length; j++) {
                if (canvas[parseInt(j.toString(), 10)].children) {
                    this.updateWrapper(canvas[parseInt(j.toString(), 10)].children, value, scaleOffsetX, scaleOffsetY, isExport);
                }
                canvas[parseInt(j.toString(), 10)].exportScaleValue.x = value;
                canvas[parseInt(j.toString(), 10)].exportScaleValue.y = value;
                canvas[parseInt(j.toString(), 10)].exportScaleOffset.x = scaleOffsetX;
                canvas[parseInt(j.toString(), 10)].exportScaleOffset.y = scaleOffsetY;
                canvas[parseInt(j.toString(), 10)].isExport = isExport;
            }
        }
    }
    scaleGradientValue(node, scaleValue, isExport) {
        if (node.style.gradient.stops.length > 0) {
            const gradients = node.style.gradient;
            if (node.style.gradient instanceof LinearGradient) {
                gradients.x1 = isExport ? gradients.x1 * scaleValue : gradients.x1 / scaleValue;
                gradients.y1 = isExport ? gradients.y1 * scaleValue : gradients.y1 / scaleValue;
                gradients.x2 = isExport ? gradients.x2 * scaleValue : gradients.x2 / scaleValue;
                gradients.y2 = isExport ? gradients.y2 * scaleValue : gradients.y2 / scaleValue;
            }
            else {
                gradients.fx = isExport ? gradients.fx * scaleValue : gradients.fx / scaleValue;
                gradients.fy = isExport ? gradients.fy * scaleValue : gradients.fy / scaleValue;
                gradients.cx = isExport ? gradients.cx * scaleValue : gradients.cx / scaleValue;
                gradients.cy = isExport ? gradients.cy * scaleValue : gradients.cy / scaleValue;
                gradients.r = isExport ? gradients.r * scaleValue : gradients.r / scaleValue;
            }
        }
    }
    updateObjectValue(value, scaleOffsetX, scaleOffsetY, isExport) {
        let wrapper;
        for (let i = 0; i < this.diagram.nodes.length; i++) {
            wrapper = this.diagram.nodes[parseInt(i.toString(), 10)].wrapper;
            this.scaleGradientValue(this.diagram.nodes[parseInt(i.toString(), 10)], value, isExport);
            this.updateWrapper(wrapper.children, value, scaleOffsetX, scaleOffsetY, isExport);
            wrapper.exportScaleValue.x = value;
            wrapper.exportScaleValue.y = value;
            wrapper.exportScaleOffset.x = scaleOffsetX;
            wrapper.exportScaleOffset.y = scaleOffsetY;
            wrapper.isExport = isExport;
        }
        for (let j = 0; j < this.diagram.connectors.length; j++) {
            wrapper = this.diagram.connectors[parseInt(j.toString(), 10)].wrapper;
            for (let k = 0; k < wrapper.children.length; k++) {
                wrapper.children[parseInt(k.toString(), 10)].isExport = isExport;
                if (isExport) {
                    wrapper.children[parseInt(k.toString(), 10)].exportScaleValue.x = value;
                    wrapper.children[parseInt(k.toString(), 10)].exportScaleValue.y = value;
                    wrapper.children[parseInt(k.toString(), 10)].exportScaleOffset.x = scaleOffsetX;
                    wrapper.children[parseInt(k.toString(), 10)].exportScaleOffset.y = scaleOffsetY;
                }
            }
        }
    }
    isImageExportable(backgroundImage) {
        let state = true;
        let content;
        let canvas;
        if (backgroundImage.source) {
            try {
                canvas = CanvasRenderer.createCanvas(this.diagram.element.id + 'temp_canvas', 100, 100);
                const ctx = canvas.getContext('2d');
                ctx.save();
                const image = new Image();
                image.src = backgroundImage.source;
                ctx.drawImage(image, 0, 0, 100, 100);
                ctx.restore();
                content = canvas.toDataURL();
            }
            catch (e) {
                state = false;
            }
        }
        return state;
    }
    getPrintCanvasStyle(img, options) {
        let width = 0;
        let height = 0;
        const size = new Size();
        width = img.width;
        height = img.height;
        if (options.pageHeight || options.pageWidth) {
            height = options.pageHeight ? options.pageHeight : height;
            width = options.pageWidth ? options.pageWidth : width;
        }
        if (options.pageOrientation) {
            if ((options.pageOrientation === 'Landscape' && height > width) || options.pageOrientation === 'Portrait' && width > height) {
                const temp = width;
                width = height;
                height = temp;
            }
        }
        size.height = height;
        size.width = width;
        return size;
    }
    getMultipleImage(img, options, isExport) {
        const imageArray = [];
        const div = createHtmlElement('div', {});
        const pageSize = this.getPrintCanvasStyle(img, options);
        //let pageWidth: number;
        //let pageHeight: number;
        const margin = options.margin;
        const mLeft = margin.left;
        const mTop = margin.top;
        const mRight = margin.right;
        const mBottom = margin.bottom;
        let x = 0;
        const y = 0;
        const pageWidth = pageSize.width + x;
        const pageHeight = pageSize.height + y;
        let drawnX = 0;
        let drawnY = 0;
        if (options && options.multiplePage) {
            div.style.height = 'auto';
            div.style.width = 'auto';
            const imgHeight = img.height;
            const imgWidth = img.width;
            //if (img) {
            let i = 0;
            let j = 0;
            let url;
            let clipWidth = 0;
            let clipHeight = 0;
            let ctx;
            let canvas;
            do {
                do {
                    clipWidth = pageSize.width;
                    clipHeight = pageSize.height;
                    if ((drawnX + pageSize.width) >= imgWidth) {
                        clipWidth = (imgWidth - drawnX);
                    }
                    if ((drawnY + pageSize.height) >= imgHeight) {
                        clipHeight = (imgHeight - drawnY);
                    }
                    canvas = CanvasRenderer.createCanvas(this.diagram.element.id + '_multiplePrint', pageSize.width, pageSize.height);
                    ctx = canvas.getContext('2d');
                    ctx.drawImage(img, x + drawnX + mLeft, y + drawnY + mTop, clipWidth - mRight - mLeft, clipHeight - mBottom - mTop, 0 + mLeft, 0 + mTop, clipWidth - mRight - mLeft, clipHeight - mBottom - mTop);
                    if ((drawnX + pageSize.width) >= imgWidth) {
                        drawnX -= (drawnX - imgWidth);
                    }
                    url = canvas.toDataURL();
                    ctx.restore();
                    drawnX += pageWidth;
                    if (isExport) {
                        imageArray.push(url);
                    }
                    else {
                        this.printImage(div, url, i + '' + j, pageWidth + 'px;', pageHeight + 'px;');
                    }
                    i++;
                } while (drawnX < imgWidth);
                j++;
                i = x = drawnX = 0;
                if ((drawnY + pageSize.height) >= imgHeight) {
                    drawnY -= (drawnY - imgHeight);
                }
                drawnY += pageHeight;
            } while (drawnY < imgHeight);
            //}
        }
        else {
            const x = 0;
            const y = 0;
            const pageSize = this.getPrintCanvasStyle(img, options);
            ///let pageWidth: number; let pageHeight: number;
            const pageWidth = pageSize.width;
            const pageHeight = pageSize.height;
            //let ctx: CanvasRenderingContext2D;
            //let canvas: HTMLCanvasElement;
            //let url: string;
            const canvas = CanvasRenderer.createCanvas(this.diagram.element.id + '_diagram', pageWidth, pageHeight);
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, x + mLeft, y + mTop, img.width - (mRight + mLeft), img.height - (mTop + mBottom), 0 + mLeft, 0 + mTop, pageWidth - (mRight + mLeft), pageHeight - (mTop + mBottom));
            const url = canvas.toDataURL();
            ctx.restore();
            if (isExport) {
                imageArray.push(url);
            }
            else {
                this.printImage(div, url, 0);
            }
        }
        if (isExport) {
            return imageArray;
        }
        else {
            return div;
        }
    }
    printImage(div, url, i, pageWidth, pageHeight) {
        let attr = { 'class': 'e-diagram-print-page', 'style': 'width:' + pageWidth + 'height:' + pageHeight };
        const img = createHtmlElement('img', attr);
        const innerDiv = createHtmlElement('div', attr);
        attr = { 'id': this.diagram.element.id + '_multiplePrint_img' + i, 'style': 'float:left', 'src': url };
        setAttributeHtml(img, attr);
        innerDiv.appendChild(img);
        div.appendChild(innerDiv);
    }
    /**
     * To print the image
     *
     * @private
     */
    print(options) {
        options.mode = 'Data';
        const url = this.exportDiagram(options);
        this.printImages(url, options);
    }
    printImages(url, options) {
        const attr = {
            'id': this.diagram.element.id + '_printImage',
            'src': url
        };
        options.margin = { top: 0, bottom: 0, right: 0, left: 0 };
        const img = createHtmlElement('img', attr);
        img.onload = () => {
            const div = this.getMultipleImage(img, options);
            // specify window parameters
            const printWind = window.open('');
            this.printWindow = printWind;
            if (printWind != null) {
                if ((div instanceof HTMLElement)) {
                    printWind.document.write('<html><head><style> body{margin:0px;}  @media print { .e-diagram-print-page' +
                        '{page-break-after: left; }.e-diagram-print-page:last-child {page-break-after: avoid;}}' +
                        '</style><title></title></head>');
                    //833683-Need to close print window after closing the parent window
                    window.addEventListener('beforeunload', this.closePrintWindow);
                    printWind.addEventListener('load', () => {
                        setTimeout(() => {
                            printWind.window.print();
                            //To close new window once print window is closed
                            printWind.close();
                        }, 3000);
                    });
                    printWind.document.write('<center>' + div.innerHTML + '</center>');
                    printWind.document.close();
                }
            }
        };
    }
    getContent(styleSheets) {
        const snapConstraints = this.diagram.snapSettings.constraints;
        this.diagram.snapSettings.constraints = (this.diagram.snapSettings.constraints & ~SnapConstraints.ShowLines);
        this.diagram.dataBind();
        this.diagram.clearSelection();
        styleSheets = styleSheets || document.styleSheets;
        let styleSheetRef = '';
        for (let i = 0; i < styleSheets.length; i++) {
            if (styleSheets[parseInt(i.toString(), 10)].href || typeof styleSheets[parseInt(i.toString(), 10)] === 'string') {
                styleSheetRef += '<link href=\'' + (styleSheets[parseInt(i.toString(), 10)].href || styleSheets[parseInt(i.toString(), 10)]) + '\' rel=\'stylesheet\' />';
            }
        }
        let htmlData = document.getElementById(this.diagram.element.id + 'content').innerHTML;
        const marginStyle = 'margin-left:' + 0 + 'px;margin-top:' + 0 + 'px;margin-right:'
            + 0 + 'px;margin-bottom:' + 0 + 'px;';
        htmlData = styleSheetRef + '<body style="margin: 0px; padding: 0px"><div style=\'' +
            marginStyle + '\'>' + htmlData + '</div></body>';
        htmlData = htmlData.replace(/ transform: t/g, ' -webkit-transform: t');
        this.diagram.snapSettings.constraints = snapConstraints;
        this.diagram.dataBind();
        return htmlData;
    }
    /** @private */
    getDiagramContent(styleSheets) {
        if (this.diagram.scroller.currentZoom === 1) {
            const htmlData = this.getContent(styleSheets);
            /* tslint:disable */
            // eslint-disable-next-line quotes
            return checkBrowserInfo() ? htmlData.replace("url(" + location.protocol + '//' + location.host + location.pathname + "#diagram_pattern ", "url(#diagram_pattern)") : htmlData;
            /* tslint:enable */
        }
        else {
            const container = document.getElementById(this.diagram.element.id + 'content');
            const scrollerX = container.scrollLeft;
            const scrollerY = container.scrollTop;
            const oldZoom = this.diagram.scrollSettings.currentZoom;
            const oldHorizontalOffset = this.diagram.scroller.horizontalOffset;
            const oldVerticalOffset = this.diagram.scroller.verticalOffset;
            const oldWidth = Number(String(this.diagram.width).split('%')[0]) ?
                container.clientWidth : Number(String(this.diagram.width).split('px')[0]);
            const oldHeight = Number(String(this.diagram.height).split('%')[0]) ?
                container.clientHeight : Number(String(this.diagram.height).split('px')[0]);
            const bounds = this.getDiagramBounds('', {});
            this.diagram.scroller.zoom((1 / oldZoom));
            let scrollX = 0;
            let scrollY = 0;
            scrollX = bounds.x;
            scrollY = bounds.y;
            this.diagram.scroller.transform = {
                tx: -scrollX,
                ty: -scrollY,
                scale: this.diagram.scroller.currentZoom
            };
            this.diagram.scroller.horizontalOffset = -scrollX;
            this.diagram.scroller.verticalOffset = -scrollY;
            this.diagram.scroller.setSize();
            this.diagram.setSize(bounds.width, bounds.height);
            const htmlData = this.getContent(styleSheets);
            this.diagram.setSize(oldWidth, oldHeight);
            this.diagram.scroller.zoom(oldZoom / this.diagram.scrollSettings.currentZoom);
            this.diagram.dataBind();
            if (scrollerX || scrollerY) {
                this.diagram.setOffset(scrollerX, scrollerY);
            }
            else {
                this.diagram.scroller.transform = {
                    tx: (oldHorizontalOffset) / this.diagram.scroller.currentZoom,
                    ty: (oldVerticalOffset) / this.diagram.scroller.currentZoom,
                    scale: this.diagram.scroller.currentZoom
                };
                this.diagram.scroller.horizontalOffset = oldHorizontalOffset;
                this.diagram.scroller.verticalOffset = oldVerticalOffset;
            }
            this.diagram.renderSelector(false);
            /* tslint:disable */
            // eslint-disable-next-line quotes
            return checkBrowserInfo() ? htmlData.replace("url(" + location.protocol + '//' + location.host + location.pathname + "#diagram_pattern ", "url(#diagram_pattern)") : htmlData;
            /* tslint:enable */
        }
    }
    /** @private */
    exportImages(image, options) {
        const region = options && options.region ? options.region : 'Content';
        let margin = options.margin || {};
        margin = {
            top: !isNaN(margin.top) ? margin.top : 0,
            bottom: !isNaN(margin.bottom) ? margin.bottom : 0,
            left: !isNaN(margin.left) ? margin.left : 0,
            right: !isNaN(margin.right) ? margin.right : 0
        };
        const bounds = this.getDiagramBounds(region, {});
        if (options.bounds) {
            bounds.x = (!isNaN(options.bounds.x) ? options.bounds.x : bounds.x);
            bounds.y = (!isNaN(options.bounds.y) ? options.bounds.y : bounds.y);
            bounds.width = (options.bounds.width || bounds.width);
            bounds.height = (options.bounds.height || bounds.height);
        }
        const img = document.createElement('img');
        const attr = {
            'src': image
        };
        setAttributeHtml(img, attr);
        const context = this;
        img.onload = () => {
            const canvas = CanvasRenderer.createCanvas(context.diagram.element.id + 'innerImage', bounds.width + (margin.left + margin.right), bounds.height + (margin.top + margin.bottom));
            const ctx = canvas.getContext('2d');
            ctx.fillStyle = context.diagram.pageSettings.background.color;
            ctx.fillRect(0, 0, bounds.width + (margin.left + margin.right), bounds.height + (margin.top + margin.bottom));
            ctx.drawImage(img, 0, 0, bounds.width, bounds.height, margin.left, margin.top, bounds.width, bounds.height);
            //898304 - exportImage function export images only in "png" format
            if (image && options.format === 'JPG') {
                image = canvas.toDataURL('image/jpeg');
            }
            else {
                image = canvas.toDataURL();
            }
            if (options.printOptions) {
                context.printImages(image, options);
                return;
            }
            ctx.restore();
            const fileName = options.fileName || 'diagram';
            this.canvasMultiplePage(options, canvas, margin, image, fileName);
        };
        //898304 - exportImage function export images only in "png" format
        if (options.format === 'SVG') {
            this.exportDiagram(options);
        }
    }
    /**
     *To destroy the ruler
     *
     * @returns {void} To destroy the ruler
     */
    destroy() {
        /**
         * Destroys the Print and Export module
         */
        //833683 - unwire beforeunload event on destroy
        window.removeEventListener('beforeunload', this.closePrintWindow);
        this.printWindow = undefined;
    }
    /**
     * Get module name.
     */
    getModuleName() {
        /**
         * Returns the module name
         */
        return 'PrintandExport';
    }
}
